import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { IClusterAPI } from "types/api/clusterApiInterface";
import { IServerDetails } from "types/api/serversApiInterface";

const initialState: IClusterAPI = { nodes: [], nfs: null, db: null };

const clusterReducer = createSlice({
 name: "clusterList",
 initialState,
 reducers: {
  setClusterList: (state, { payload }: PayloadAction<Array<IServerDetails>>) => {
   return { ...state, nodes: payload };
  },
  resetClusterList: (state) => {
   return { ...state, nodes: [] };
  },
  setNfsServer: (state, { payload }: PayloadAction<IServerDetails>) => {
   return { ...state, nfs: payload };
  },
  setDbServer: (state, { payload }: PayloadAction<IServerDetails>) => {
   return { ...state, db: payload };
  },
  resetDb: (state) => {
   return { ...state, db: null };
  },
  resetNfs: (state) => {
   return { ...state, nfs: null };
  },
  resetCluster: () => {
   return initialState;
  }
 }
});

export default clusterReducer;
